import InfoCard from '../molecules/InfoCard'

interface Company {
    created_at?: Date | string
    updated_at?: Date | string
    warehouses?: { name: string; city: string; address: string }[]
}

interface CompanyInfoSectionProps {
    company: Company
    formatDate: (date: Date | string) => { date: string; time: string }
}

export default function CompanyInfoSection({
    company,
    formatDate,
}: CompanyInfoSectionProps) {
    const createdInfo =
        company.created_at !== null && company.created_at !== undefined
            ? formatDate(company.created_at)
            : null
    const updatedInfo =
        company.updated_at !== null && company.updated_at !== undefined
            ? formatDate(company.updated_at)
            : null

    return (
        <div className="bg-white rounded-xl mb-8">
            <div className="bg-card rounded-xl border border-border/50">
                <div className="flex">
                    <div className="flex-1">
                        <InfoCard
                            label="Creada el"
                            value={createdInfo?.date}
                            subtitle={createdInfo?.time}
                        />
                    </div>
                    <div className="w-px bg-gray-200 my-4" />
                    <div className="flex-1">
                        <InfoCard
                            label="Última actualización"
                            value={updatedInfo?.date}
                            subtitle={updatedInfo?.time}
                        />
                    </div>
                    <div className="w-px bg-gray-200 my-4" />
                    <div className="flex-1">
                        <InfoCard
                            label="Warehouses"
                            value={
                                company.warehouses !== null &&
                                company.warehouses !== undefined
                                    ? company.warehouses.length
                                    : 0
                            }
                            subtitle="asignados"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
